/* eslint-disable unicorn/prefer-module */
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/auth";
import styles from "./Header.module.scss";

export const Header = ({ children, leftContent, centerContent, logo: logoProp, expandChildren = false }) => {
  const { pais } = useAuthContext();
  const navigate = useNavigate();

  const logoDefault = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  const logo = logoProp || logoDefault;

  return (
    <div className={styles.headerContainer}>
      <div className={styles.leftGroup}>
        <img src={logo} alt={`${pais} Logo`} className={styles.logo} onClick={() => navigate("/admin")} />
        {leftContent && <div className={styles.leftContent}>{leftContent}</div>}
      </div>
      {centerContent && <div className={styles.centerGroup}>{centerContent}</div>}
      {children && <div className={expandChildren ? styles.rightGroupExpanded : styles.rightGroup}>{children}</div>}
    </div>
  );
};
